import React from 'react';
import { Form, Tab, Tabs } from 'react-bootstrap';
import Select from 'react-select';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateJobConfigDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import {
  JobTypeEnum,
  JobTypeObj,
} from '../../../common/spdCore/validation/schemas';

import { CronBuilder } from './CronBuilder';

interface JobConfigEditorProps {
  jobConfig: CreateUpdateJobConfigDto;
  readOnly: boolean;
  propertyChange: (obj: Partial<CreateUpdateJobConfigDto>) => void;
  createErrors: (errors: string[]) => void;
}

export const JobConfigFrom: React.FC<JobConfigEditorProps> = props => {
  const typeOptions = Object.entries(JobTypeEnum)
    .map(([key, value]) => ({
      value: key as JobTypeEnum,
      label: JobTypeObj[value],
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <Tabs>
      <Tab eventKey="jobConfig" title="Zadania cykliczne" className="m-3">
        <Form className="d-grid gap-3">
          <FormRow controlId="type" label="Typ">
            <Select
              className="full-width"
              value={
                props.jobConfig.type
                  ? typeOptions.find(
                      ({ value }) => props.jobConfig.type === value,
                    )
                  : null
              }
              options={typeOptions}
              onChange={option =>
                props.propertyChange({
                  type: option?.value,
                })
              }
              isDisabled={props.readOnly}
              placeholder="Wskaż..."
            />
          </FormRow>
          <FormRow controlId="active" label="Aktywne">
            <Form.Check
              type="checkbox"
              className="pt-2"
              checked={props.jobConfig?.active ?? true}
              onChange={e => props.propertyChange({ active: e.target.checked })}
            />
          </FormRow>
        </Form>
      </Tab>

      <Tab eventKey="cron" title="Częstotliwość" className="m-3">
        <CronBuilder
          value={props.jobConfig.crone || '0 8 * * 1-5'}
          onChange={(val: string) => props.propertyChange({ crone: val })}
          language={'PL'}
          disabled={props.readOnly}
        />
      </Tab>
    </Tabs>
  );
};
